// ProductCard.jsx

function ProductCard({
  the_key, 
  imageSrc,
  imageAlt = "",
  price,
  title,
  weight,
  buttonText,
  onAddToCart,
})
 {
 
  return (
    <div
        key={the_key}
      className="card shadow-sm"
      style={{width: "100%",
    borderRadius: "15px",
    overflow: "hidden"}}
    >
      {/* תמונה למעלה */}
      <img
        src={imageSrc}
        alt={imageAlt || title}
        className="card-img-top p-2"
        style={{ height: "180px", objectFit: "cover",borderRadius:"15px" }}
      />

      {/* תוכן מתחת לתמונה */}
      <div className="card-body">
        {/* מחיר */}
        {price && (
          <span className="badge bg-success mb-2" style={{ fontSize: "1rem", padding: "8px 12px" }}>
            ${price}
          </span>
        )}

        {/* כותרת המנה */}
        <h6 className="card-title mt-1">{title}</h6>

        {/* משקל / Oz */}
        {weight && <p className="card-text text-muted mb-1">{weight}</p>}

       

        {/* כפתור הוספה לסל */}
        <button
          className="btn btn-primary w-100 mt-2"
          onClick={onAddToCart}
          type="button"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
}

export default ProductCard;
